/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierDriverContacts.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-driver-contacts";

export class AutogenModelCarrierDriverContacts<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierDriverContactsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierDriverContacts extends ModelRow<RowCarrierDriverContactsFields> {
	constructor(values?: Partial<RowCarrierDriverContactsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierDriverContactsFields {
	carrier_id: string;
	cell_phone_number: string;
	company_id: string;
	driver_name: string;
	identifier: string;
	email_address: string;
	id: number;
	is_active: string;
	is_sms_opted_in: string;
	notes: string;
	opt_out_date: Date;
	tractor_number: string;
}

